import React from 'react'
import classes from './Motto.module.css'

export default function Motto() {
  return (
    <div className={classes.mottoWrapper}>
        <h1 className={classes.motto}>
            Control your diet using victu
        </h1>
    </div>
  )
}
